import { render, staticRenderFns } from "./CouriersList.vue?vue&type=template&id=74d13060&scoped=true&"
import script from "./CouriersList.vue?vue&type=script&lang=js&"
export * from "./CouriersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d13060",
  null
  
)

export default component.exports